import { styled } from '@mui/material/styles';

import {
    Theme,
    containerLargeWidth,
    containerSmallWidth,
    px,
    rem,
    remToGapMultiplier,
} from '../../theme';
import { Heading } from '../Heading';
import { HorizontalRule } from '../HorizontalRule';
import { Paragraph } from '../Paragraph';

export const StyledWrapper = styled('div')<{
    $isMBTOptimizationV2orV3?: boolean;
}>`
    ${({
        theme,
        $isMBTOptimizationV2orV3,
    }: {
        theme: Theme;
        $isMBTOptimizationV2orV3?: boolean;
    }) => `
        max-width: 100%;
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};

        ${theme.breakpoints.up('desktop')} {
            width: 100%;
            max-width: ${theme.tggSpacing(rem(containerLargeWidth), 211)};
        }

        .pino-option {
            border-radius: ${$isMBTOptimizationV2orV3 && theme.tggSpacing(0, 0)};
        }
	`}
`;

export const StyledHeaderSection = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([0, rem(3)], [0, 7.5])};

        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing(0, 0)};
            text-align: center;
        }
	`}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin-right: ${theme.tggSpacing(0, 0)};
        margin-left: ${theme.tggSpacing(0, 0)};
	`}
`;

export const StyledExpanderHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_18_bold};
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([0, 0, 0, rem(1.5)], [0, 0, 0, 3.75])};
        margin-right: ${theme.tggSpacing(0, 0)};
        margin-left: ${theme.tggSpacing(0, 0)};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([0, 0, 0, rem(3)], [0, 0, 0, 7.5])};
        }
	`}
`;

export const StyledDescription = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(containerSmallWidth), containerSmallWidth * remToGapMultiplier)};
            margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
        }
	`}
`;

export const StyledPanelsWithHeaderWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(px(20), 5)};
	`}
`;

export const StyledExpanderSection = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(1), 2.5)};
	`}
`;

export const FullBenefitsWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        padding-left: ${theme.tggSpacing(rem(0.8), 3)};

        ${theme.breakpoints.up('desktop')} {
            padding-left: ${theme.tggSpacing(rem(2.3), 9)};
        }
	`}
`;

export const StyledRadioContainer = styled('label')<{
    $checked?: boolean;
    $variant: 'green' | 'blue';
}>`
    ${({
        theme,
        $variant,
        $checked,
    }: {
        theme: Theme;
        $checked?: boolean;
        $variant: 'green' | 'blue';
    }) => `
        position: relative;
        width: ${theme.tggSpacing(rem(4.2), 17)};
        height: ${theme.tggSpacing(rem(4.2), 17)};
        margin: ${theme.tggSpacing([rem(2), 0], [5, 0])};
        background-color: ${theme.palette.common.white};
        border: ${theme.tggSpacing(px(1), 0.25)} solid
            ${theme.palette.grey[900]};
        border-radius: ${theme.tggSpacing(rem(2.25), 5.625)};
        input {
            position: absolute;
            width: ${theme.tggSpacing(rem(4.2), 17)};
            height: ${theme.tggSpacing(rem(4.2), 17)};
            opacity: 0;

            + div {
                padding: ${theme.tggSpacing(rem(0.5), 1.25)};
            }
        }
        svg {
            margin: ${theme.tggSpacing(rem(0.1), 0.25)};
            ${$checked && `margin: ${theme.tggSpacing(rem(0.2), 1)};`}
        }
	`}
`;

export const StyledJoinButtonContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;
        max-width: ${theme.tggSpacing(rem(34.6), 86.5)};
        margin: ${theme.tggSpacing([rem(3), 'auto'], [0, 'auto'])};
	`}
`;

export const StyledFixedMembershipParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([rem(1), 0, 0, rem(3)], [2.5, 0, 0, 7.5])};
        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([rem(1), rem(20), 0, rem(20)], [2.5, 50, 0, 50])};
        }
	`}
`;

export const StyledFixedHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([0, 0, rem(1), 0], [4, 0, 0, 12])};
        text-align: center;
	`}
`;

export const StyledPanelsFixedHeader = styled(Heading)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing(0, 0)};
        text-align: center;
	`}
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(3), 0, rem(2), 0], [7.5, 0, 5, 0])};
	`}
`;

export const StyledHeadContainer = styled('section')`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(rem(1), 2.5)};
        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([rem(1), rem(4), rem(2)], [2.5, 10, 5])};
            text-align: center;
        }
	`}
`;

export const StyledHeadProductsTitle = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        font-size: 2.3rem;
        ${theme.breakpoints.up('desktop')} {
            font-size: 2.6rem;
        }
	`}
`;

export const StyledHeadProductsText = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
	`}

    && {
        ${({ theme }: { theme: Theme }) => theme.typography.text_14};
    }
`;

export const StyledHeadProductsContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        gap: ${theme.tggSpacing(rem(2), 5)};
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        ${theme.breakpoints.up('desktop')} {
            justify-content: center;
        }
	`}
`;

export const StyledHeadProductContainer = styled('div')`
    display: flex;
    flex-direction: column;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        align-items: center;
    }
`;

export const StyledHeadProductDescriptionTile = styled('div')`
    display: flex;
    gap: ${({ theme }: { theme: Theme }) => theme.tggSpacing(rem(0.4), 1)};
    align-items: center;
    font-size: 1.4rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        justify-content: center;
    }
`;

export const StyledHeadProductHeading = styled('span')`
    ${({ theme }) => theme.typography.text_14_bold_lh_12_sans};

    ${({ theme }: { theme: Theme }) => `
        height: ${theme.tggSpacing(rem(1.5), 3.75)};

        ${theme.breakpoints.up('desktop')} {
            height: ${theme.tggSpacing(rem(1.6), 4)};
        }
	`}
`;

export const StyledHeadProductText = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12};
    ${({ theme }: { theme: Theme }) => `
        padding-top: ${theme.tggSpacing(rem(0.2), 1)};
	`}

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        ${({ theme }: { theme: Theme }) => theme.typography.text_14};
        max-width: ${({ theme }: { theme: Theme }) =>
            theme.tggSpacing(rem(18), 45)};
    }
`;
